import { render, staticRenderFns } from "./ClaimDetails.vue?vue&type=template&id=85e1ba48&scoped=true"
import script from "./ClaimDetails.vue?vue&type=script&lang=js"
export * from "./ClaimDetails.vue?vue&type=script&lang=js"
import style0 from "./ClaimDetails.vue?vue&type=style&index=0&id=85e1ba48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e1ba48",
  null
  
)

export default component.exports